import { render, staticRenderFns } from "./Feriapp.vue?vue&type=template&id=6559780b&"
import script from "./Feriapp.vue?vue&type=script&lang=js&"
export * from "./Feriapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports